<!-- Section Details Component -->
<div class="modal-header">
  <h3 class="modal-title">
    View/Edit Section
    <i (click)="cancel()" class="fa fa-times pull-right" style="cursor: pointer;"></i>
    <i class="fa pull-right" [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
      style="margin-right: 10px; cursor: pointer;" (click)="minimise=!minimise"></i>
  </h3>
</div>

<div [hidden]="minimise">

  <div class="row" style="width: 100%; text-align: CENTER; border : 0px;">
    <h4>Section {{sectionName}} Property</h4>
  </div>

  @if (dataRow?.IS_EDITTED=='Y') {
<div>
    <div class="row" style="width: 100%; text-align: CENTER; border : 0px;">
      <h4>Please save the Form 4797 Transaction to enter the Section Details</h4>
    </div>
  </div>
}

  @if (dataRow?.IS_EDITTED!='Y') {
<div class="body-style" >
    <table class="table table-bordered form-inline InnerTblBG">
      <tbody>
        @for (row of sectionFormData; track $index; let i = $index) {
<tr>
          <td>{{ row.ATTRIB_DESCRIPTION }}</td>
          @if (row.DATA_TYPE==='number' && row.EDIT_TYPE=='currency') {
<td>
            <input style="text-align: right;" [(ngModel)]="row.ATTRIB_VALUE" [disabled]="row.IS_EDITABLE==='N'"
              class="form-control input-md numText" (ngModelChange)="valuechanged(i)" type="text">
          </td>
}
          @if (row.EDIT_TYPE==='select' && row.DATA_TYPE==='string' && sectionName === '1252') {
<td>
            <select class="form-control" [(ngModel)]="sel_multiplier" (ngModelChange)="drpDownChange(row, i)" required>
              <option [ngValue]="null">Select</option>
              @for (option of percentDrpDwnData; track $index) {
<option [ngValue]="option">
                {{ option.LABEL }}
              </option>
}
            </select>
          </td>
}
        </tr>
}
      </tbody>
    </table>
  </div>
}
</div>
<div class="modal-footer">
  <button class="btn btn-info btn-sm" [disabled]="dataRow?.IS_EDITTED=='Y' || crudLoading" type="button"
    (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
} Save
  </button>
  <button class="btn btn-warning btn-sm" type="button" (click)="cancel()">Cancel</button>
</div>